import React from 'react'
import ReactDOM from 'react-dom'
import NavigationSearch from './NavigationSearch.jsx'

const elmentName = 'navigation-search'
customElements.get(elmentName) ||
  (function () {
    class NavigationSearchElement extends HTMLElement {
      connectedCallback() {
        const action = this.dataset?.action
        const name = this.dataset?.name
        const isMobile = this.dataset?.mobile === 'true' ? true : false
        if (action) {
          const reactContainerClassName = elmentName
          const reactContainer = document.createElement('div')
          reactContainer.setAttribute('class', reactContainerClassName)
          this.appendChild(reactContainer)
          ReactDOM.render(
            <NavigationSearch
              {...{
                action,
                name,
                isMobile,
              }}
            />,
            reactContainer
          )
        }
      }
    }

    customElements.define(elmentName, NavigationSearchElement)
  })()
